import type { NotificationRemoteData } from '@notifications/services/types'
import AbstractNotification from '@notifications/models/AbstractNotification'
import router from '@/router'

export default class NotificationProsvet extends AbstractNotification {
  link: string

  get title() {
    return this.link
  }

  get message() {
    return `Добрый день! При необходимости вы можете скорректировать свои данные по ссылке:`
  }

  constructor(data: NotificationRemoteData) {
    super(data)
    this.link = data.reference_data?.link ?? ''
  }

  onActionClick() {
    router.push({
      name: 'CoursesItem',
      params: {
        courseId: this.link
      }
    })
  }
}
